var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { defineComponent, useAttrs, useSlots, inject, createBlock, openBlock, unref, mergeProps, isRef, withCtx, createVNode, normalizeClass, createCommentVNode, createElementVNode, renderSlot, normalizeProps, resolveDynamicComponent, isVNode } from "vue";
import { useVModel } from "../../../../node_modules/.pnpm/@vueuse_core@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/core/index.js";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { Field } from "vee-validate";
import { useSlotsExists } from "../../../../composables/useSlotsExists.js";
import { SmartRenderer, resolveVNode, vnodeBindingVModel } from "../../../../lib/utils.js";
import _sfc_main$6 from "../core/FormControl.js";
import _sfc_main$4 from "../core/FormDescription.js";
import _sfc_main$1 from "../core/FormItem.js";
import _sfc_main$3 from "../core/FormLabel.js";
import _sfc_main$5 from "../core/FormMessage.js";
import { LAYOUT_INJECTION_KEY } from "../injectionKeys.js";
import { itemVariants, componentVariants, formLabelVariants } from "../styles/index.js";
import _sfc_main$2 from "./FormWrapperItemLayout.js";
import { S as Slot } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Primitive/Slot.js";
import omit from "../../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omit.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
function _isSlot(s) {
  return typeof s == "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
__name(_isSlot, "_isSlot");
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormWrapperItem",
  props: {
    label: {
      type: [Object, String, Number, Boolean, null, Array, Function]
    },
    name: {},
    description: {
      type: [Object, String, Number, Boolean, null, Array, Function]
    },
    type: {},
    class: {},
    classes: {},
    controlRender: {
      type: Function
    },
    modelValue: {}
  },
  setup(__props) {
    const props = __props, attrs = useAttrs(), slots = useSlots(), slotsExists = useSlotsExists(["label", "control", "default", "description"]), fieldProps = reactiveOmit(props, ["label"]), modelValue = useVModel(props, "modelValue"), layout = inject(LAYOUT_INJECTION_KEY);
    function formControlVNode(componentField, field) {
      if (slotsExists.value.default && slots.default) {
        const vnode = slots.default()[0], isCheckbox = props.type === "checkbox";
        if (typeof vnode.type == "string")
          return createVNode(_sfc_main$6, null, {
            default: /* @__PURE__ */ __name(() => [createVNode(Slot, field, _isSlot(vnode) ? vnode : {
              default: /* @__PURE__ */ __name(() => [vnode], "default")
            })], "default")
          });
        const componentFieldObject = isCheckbox ? componentField : vnodeBindingVModel(vnode.props) ? omit(componentField, ["modelValue"]) : componentField;
        return createVNode(_sfc_main$6, null, {
          default: /* @__PURE__ */ __name(() => [createVNode(Slot, componentFieldObject, _isSlot(vnode) ? vnode : {
            default: /* @__PURE__ */ __name(() => [vnode], "default")
          })], "default")
        });
      }
      return null;
    }
    return __name(formControlVNode, "formControlVNode"), (_ctx, _cache) => (openBlock(), createBlock(unref(Field), mergeProps({
      modelValue: unref(modelValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(modelValue) ? modelValue.value = $event : null)
    }, {
      ...unref(fieldProps),
      ...unref(attrs)
    }, {
      name: props.name,
      type: props.type
    }), {
      default: withCtx(({
        componentField,
        field,
        meta
      }) => [createVNode(_sfc_main$1, {
        class: normalizeClass(unref(cn)(unref(itemVariants)({
          layout: unref(layout)
        }), props.class))
      }, {
        default: withCtx(() => [createVNode(_sfc_main$2, {
          class: normalizeClass(unref(componentVariants)({
            layout: unref(layout)
          })),
          "is-horizontal-layout": unref(layout) === "horizontal" || unref(layout) === "inline"
        }, {
          default: withCtx(() => {
            var _a, _b, _c, _d;
            return [unref(slotsExists).label || props.label ? (openBlock(), createBlock(_sfc_main$3, {
              key: 0,
              class: normalizeClass(unref(cn)(unref(formLabelVariants)({
                layout: unref(layout)
              }), (_a = props == null ? void 0 : props.classes) == null ? void 0 : _a.label)),
              required: unref(slotsExists).label ? !1 : meta.required
            }, {
              default: withCtx(() => [renderSlot(_ctx.$slots, "label", {
                meta
              }, () => [createVNode(unref(SmartRenderer), {
                children: unref(resolveVNode)(props.label)
              }, null, 8, ["children"])])]),
              _: 2
            }, 1032, ["class", "required"])) : createCommentVNode("", !0), createElementVNode("div", {
              class: normalizeClass((_b = props == null ? void 0 : props.classes) == null ? void 0 : _b.control),
              "data-slot": "form-control"
            }, [unref(slotsExists).control ? renderSlot(_ctx.$slots, "control", normalizeProps(mergeProps({
              key: 0
            }, {
              node: formControlVNode(componentField, field)
            }))) : props.controlRender ? (openBlock(), createBlock(resolveDynamicComponent(props.controlRender(formControlVNode(componentField, field))), {
              key: 1
            })) : unref(slotsExists).default ? (openBlock(), createBlock(resolveDynamicComponent(formControlVNode(componentField, field)), {
              key: 2
            })) : createCommentVNode("", !0), unref(slotsExists).description || props.description ? (openBlock(), createBlock(_sfc_main$4, {
              key: 3,
              class: normalizeClass((_c = props == null ? void 0 : props.classes) == null ? void 0 : _c.description)
            }, {
              default: withCtx(() => [renderSlot(_ctx.$slots, "description", {}, () => [createVNode(unref(SmartRenderer), {
                children: unref(resolveVNode)(props.description)
              }, null, 8, ["children"])])]),
              _: 3
            }, 8, ["class"])) : createCommentVNode("", !0), createVNode(_sfc_main$5, {
              class: normalizeClass((_d = props == null ? void 0 : props.classes) == null ? void 0 : _d.message)
            }, null, 8, ["class"])], 2)];
          }),
          _: 2
        }, 1032, ["class", "is-horizontal-layout"])]),
        _: 2
      }, 1032, ["class"])]),
      _: 3
    }, 16, ["modelValue", "name", "type"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormWrapperItem.js.map
